import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { PlusIcon, BookOpenIcon, GiftIcon, StampIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { ConfettiRain } from './ConfettiRain';
const parts = [{
  icon: BookOpenIcon,
  title: 'El Gran Reto Creativo',
  sub: '365 actividades organizadas y explicadas',
  color: '#2D8C5A',
  tint: '#E9F6EE'
}, {
  icon: GiftIcon,
  title: '10 bonos gratis',
  sub: 'Recursos para organizar y acompañar',
  color: '#F3A340',
  tint: '#FDEFE2'
}, {
  icon: StampIcon,
  title: 'Pasaporte de retos creativos',
  sub: 'Regalo sorpresa incluido',
  color: '#6CBBD5',
  tint: '#E6F2FB'
}];
export function Bundle() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream2 py-16 sm:py-20" aria-labelledby="bundle-title" data-id="element-91" data-mp="2f4ullxbgdxft">
      <ConfettiRain count={14} opacity={0.5} data-id="element-92" data-mp="2aaqgzkpnu1hw" />

      <div className="relative mx-auto max-w-content px-5 sm:px-8" data-id="element-93" data-mp="1kifyy4rux75a">
        <Reveal data-id="element-94" data-mp="1pg7vxd7czjgc">
          <h2 id="bundle-title" className="mx-auto max-w-2xl text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-95" data-mp="1pgr6u9yld7kv">
            Tu compra incluye <span className="text-tangerine" data-id="element-96" data-mp="1fpdc0fhl4vy2">mucho más</span>
          </h2>
        </Reveal>

        <ul className="mx-auto mt-10 grid max-w-4xl grid-cols-1 items-stretch gap-4 md:grid-cols-3" data-id="element-97" data-mp="11pvhrklisqhb">
          {parts.map((p, i) => {
          const Icon = p.icon;
          return <Reveal as="li" key={p.title} delay={i * 0.08} data-id="element-98" data-mp="rtiscyx0cysd" data-mpi={i}>
                <div className="relative flex h-full flex-col items-center rounded-3xl bg-white p-6 text-center shadow-soft transition-transform duration-300 hover:-translate-y-1.5 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
              borderTop: `5px solid ${p.color}`
            }} data-id="element-99" data-mp="wrtzv2ztyx7f">
                  {i > 0 && <span className="absolute -left-3 top-1/2 hidden h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-soft md:flex" aria-hidden="true" data-id="element-100" data-mp="2pml60z7xdabd">
                      <PlusIcon className="h-4 w-4 text-tangerine" data-id="element-101" data-mp="2bpoib6n3s8yp" />
                    </span>}
                  <motion.span className="flex h-14 w-14 items-center justify-center rounded-2xl" style={{
                backgroundColor: p.tint
              }} animate={reduce ? undefined : {
                y: [0, -7, 0],
                rotate: [-3, 3, -3]
              }} transition={{
                duration: 5 + i,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: i * 0.3
              }} data-id="element-102" data-mp="38e4893u4kkcc">
                    <Icon className="h-6 w-6" style={{
                  color: p.color
                }} aria-hidden="true" data-id="element-103" data-mp="3mdvq5fnrikvm" />
                  </motion.span>
                  <h3 className="mt-4 font-display text-base font-extrabold uppercase leading-snug text-navy" data-id="element-104" data-mp="18y55hpklip6r">
                    {p.title}
                  </h3>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-muted" data-id="element-105" data-mp="1hwpgs5nttwky">{p.sub}</p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}